import { useQuery } from "@tanstack/react-query";

import UserService from "@/api/services/user";

export function useUser() {
  return useQuery({
    queryKey: ["user"],
    queryFn: () => UserService.getUser(),
  });
}

export function useUsers() {
  return useQuery({
    queryKey: ["users"],
    queryFn: () => UserService.getUsers(),
  });
}
